// The native Android app (Capacitor, see capacitor.config.ts) and its plugins. In a browser, isNative() is false and
// the app uses the web features instead.
import { Capacitor, registerPlugin } from "@capacitor/core";
import type { BackgroundGeolocationPlugin } from "@capacitor-community/background-geolocation";

/** True inside the Android app from Google Play (not in a browser or the home-screen web app). */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/** Records the trip route also with the screen off (a foreground service with a notification). */
export const BackgroundGeolocation = registerPlugin<BackgroundGeolocationPlugin>("BackgroundGeolocation");

/** The installed app has Firebase built in (see capacitor.config.ts), so native notifications can be used.
 *  Without it, calling Firebase could crash the app. */
export const hasNativePush = (): boolean => isNative() && /\bReelHuntApp\b.*\bfcm\b/.test(navigator.userAgent);

export { PushNotifications } from "@capacitor/push-notifications";
export { Filesystem, Directory } from "@capacitor/filesystem";
export { Share } from "@capacitor/share";
export { LocalNotifications } from "@capacitor/local-notifications";
